import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getNationFlag'
})
export class GetNationFlagPipe implements PipeTransform {

  transform(value: string): string {
   const prefixClass ='flag-icon flag-icon-'
    switch (value) {
       case 'en':
            return `${prefixClass}gb`;
        case 'da':
            return `${prefixClass}dk`
        case 'sv':
            return `${prefixClass}se`
        case 'sl':
            return `${prefixClass}sk`
        default:
            return `${prefixClass}${value}`;
    }
  }

}
